import normalize from 'json-api-normalizer';
import Survey from './survey.js';

export default class FurthestVisitedPage {
	static from (jsonapi) {
		let normalizedJSONapi = normalize(jsonapi);
		if (Object.keys(normalizedJSONapi).length == 0) return null;

		let key = Object.keys(normalizedJSONapi)[0]  // Pages come in many types
		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = FurthestVisitedPage.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return FurthestVisitedPage.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi, noRelationships=0) {
		const { id, attributes } = jsonapi;
		
		if (normalizedJSONapi.pageViews && normalizedJSONapi.pageViews[id].attributes.pType == 'surveys') {
			attributes.title = (normalizedJSONapi.surveys && normalizedJSONapi.surveys[Object.keys(normalizedJSONapi.surveys)] && normalizedJSONapi.surveys[Object.keys(normalizedJSONapi.surveys)].attributes.title) ? normalizedJSONapi.surveys[Object.keys(normalizedJSONapi.surveys)].attributes.title : '';
			attributes.internalName = (normalizedJSONapi.surveys && normalizedJSONapi.surveys[Object.keys(normalizedJSONapi.surveys)] && normalizedJSONapi.surveys[Object.keys(normalizedJSONapi.surveys)].attributes.internalName) ? normalizedJSONapi.surveys[Object.keys(normalizedJSONapi.surveys)].attributes.internalName : '';
			attributes.slidePosition = (normalizedJSONapi.surveys && normalizedJSONapi.surveys[Object.keys(normalizedJSONapi.surveys)] && normalizedJSONapi.surveys[Object.keys(normalizedJSONapi.surveys)].attributes.slidePosition) ? normalizedJSONapi.surveys[Object.keys(normalizedJSONapi.surveys)].attributes.slidePosition : -1;
			return new FurthestVisitedPage ( Object.assign({}, {id: id}, attributes) );
		}
		else {
			attributes.title = (normalizedJSONapi.pages && normalizedJSONapi.pages[attributes.pageId] && normalizedJSONapi.pages[attributes.pageId].attributes.title) ? normalizedJSONapi.pages[attributes.pageId].attributes.title : '';
			attributes.internalName = (normalizedJSONapi.pages && normalizedJSONapi.pages[attributes.pageId] && normalizedJSONapi.pages[attributes.pageId].attributes.internalName) ? normalizedJSONapi.pages[attributes.pageId].attributes.internalName : '';
			attributes.slidePosition = (normalizedJSONapi.pages && normalizedJSONapi.pages[attributes.pageId] && normalizedJSONapi.pages[attributes.pageId].attributes.slidePosition) ? normalizedJSONapi.pages[attributes.pageId].attributes.slidePosition : -1;
			return new FurthestVisitedPage ( Object.assign({}, {id: id}, attributes) );
		}
		
	}

	constructor ({ id, title, internalName, lastVisitAt, slidePosition, enrollmentId, stageId, taskId, pType}) {
		this.id            = id ? id : -1;
		this.title    = title ? title : null;
		this.internal_name = internalName ? internalName : '';
		this.last_visit_at = lastVisitAt ? lastVisitAt : '';
		this.slide_position = slidePosition ? slidePosition : -1;
		this.enrollment_id = enrollmentId ? enrollmentId : -1;
		this.stage_id		= stageId ? stageId : -1;
		this.task_id		= taskId ? taskId : -1;
		this.p_type		= pType ? pType : '';

	}
}
